import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IPaymentPlan_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPaymentPlan_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class PaymentPlan_ScreenBase extends React.PureComponent<
  IPaymentPlan_ScreenProps,
  any
> {
  paymentplan_303901_value_kuikaSelectBoxRef: React.RefObject<any>;
  paymentplan_730750_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "008e6b7d-f191-4c95-92c4-9acd603aa7ef",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 431533, PropertyName: "value", Value: "Ödeme Planı Hesapla" },
        {
          Id: 482441,
          PropertyName: "value",
          Value: "ARYILDIZ MIA GOLD 24 PARÇA YEMEK TAKIMI",
        },
        { Id: 279095, PropertyName: "value", Value: "153AR998354" },
        { Id: 571161, PropertyName: "value", Value: "₺2.399,90" },
        { Id: 925458, PropertyName: "value", Value: "Ödeme Planı" },
        { Id: 303901, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 596001, PropertyName: "value", Value: "Peşinat" },
        { Id: 328714, PropertyName: "placeholder", Value: "15" },
        { Id: 194425, PropertyName: "label", Value: "Hesapla" },
        { Id: 42167, PropertyName: "title", Value: "Title" },
        { Id: 273639, PropertyName: "value", Value: "1" },
        { Id: 921076, PropertyName: "value", Value: "04.2025" },
        { Id: 468923, PropertyName: "value", Value: "14" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.paymentplan_303901_value_kuikaSelectBoxRef = React.createRef();
    this.paymentplan_730750_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("paymentplan", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("paymentplan", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("paymentplan", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      paymentplan_328714_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
